import React from 'react';
import BetaIcon, { IconSizes } from '../Icons/Icon';

const StarCounter = ({
  score,
  allowHalf = false,
}) => {

  if (!score) {
    return '';
  }
  const scoreValue = parseInt(score);

  const roundToHalfDecimal = (n) => Math.round(n * 2) / 2;
  const roundToWholeNumber = (n) => Math.round(n);

  const mapNumberToStarIconNames = (n) => {
    const roundedScore = allowHalf ? roundToHalfDecimal(n) : roundToWholeNumber(n);
    const fullStars = Math.floor(roundedScore); // Safe calculation
    const hasHalfStar = allowHalf && roundedScore % 1 !== 0;
    const totalStars = hasHalfStar ? fullStars + 1 : fullStars;

    const filledStars = Array(fullStars).fill('valutationStar1');
    const halfStar = hasHalfStar ? ['valutationStar05'] : [];
    const emptyStars = Array(5 - totalStars).fill('valutationStar0');

    return [...filledStars, ...halfStar, ...emptyStars];
  };

  return (
    <div className="d-flex gap-05-base ">
      {mapNumberToStarIconNames(scoreValue).map((iconName, i) => (
        <BetaIcon key={`${iconName}-${i}`} name={iconName} size={IconSizes.small} />
      ))}
    </div>
  );
};

export { StarCounter };